import {hydrateKnowledgeFactApprovals} from './knowledgeFactApproval';
import { getCareSourceById } from "../careSourceProcessing/careSourceLookupService";
import { getCareSourceAttribution } from "../careSourceProcessing/careSourceAttribution";

export const hydrateKnowledgeFactSources = async (
  facts,
  lookup = getCareSourceById,
) => {
  const sources = new Map();
  const read = (id) => {
    if (!sources.has(id))
      sources.set(
        id,
        Promise.resolve()
          .then(() => lookup(id))
          .catch(() => null),
      );
    return sources.get(id);
  };
  return Promise.all(
    facts.map(async (fact) => ({
      ...fact,
      sourceRefs: await Promise.all(
        (fact.sourceRefs || []).map(async (ref) => {
          if (
            ref.sourceCollection !== "careSources" ||
            !ref.sourceId ||
            (ref.authorName && ref.capturedAt)
          )
            return ref;
          const source = await read(ref.sourceId);
          if (!source || source.childId !== fact.childId) return ref;
          const attribution = getCareSourceAttribution(source);
          return {
            ...ref,
            authorId: attribution.authorId || ref.authorId || "",
            authorName: attribution.authorName || ref.authorName || "",
            capturedAt: attribution.capturedAt || ref.capturedAt || null,
          };
        }),
      ),
    })),
  ).then(hydrateKnowledgeFactApprovals);
};
